// extracted by mini-css-extract-plugin
export default {"popup":"Map--popup--3dZjv","closeBtn":"Map--closeBtn--a3P4c"};